import { useTranslate } from "@tolgee/react";
import { Button } from "#/components/ui/button.tsx";
import { cn } from "#/lib/utils";
import type { OrderSide } from "./constants/order-form.constants.ts";

type QuickPriceButtonProps = {
	side: OrderSide;
	price?: string;
	onApplyPrice: (price: string) => void;
	disabled?: boolean;
	showPrice?: boolean;
	className?: string;
	compactOnMobile?: boolean;
};

export function QuickPriceButton({
	side,
	price,
	onApplyPrice,
	disabled = false,
	showPrice = false,
	className,
	compactOnMobile = true,
}: QuickPriceButtonProps) {
	const { t } = useTranslate();
	const isBuy = side === "buy";
	const isBidPrice = isBuy;
	const desktopLabel = t(
		isBidPrice ? "form.quick-price.bid" : "form.quick-price.ask",
	);
	const mobileLabel = t("form.quick-price.mobile");
	const canApply = Boolean(price) && !disabled;
	const desktopText = showPrice && price ? `${desktopLabel} ${price}` : desktopLabel;
	const mobileText = compactOnMobile ? mobileLabel : desktopLabel;

	return (
		<Button
			type="button"
			variant="ghost"
			size="xs"
			disabled={!canApply}
			className={cn(
				"h-5 rounded-[5px] border px-1.5 text-caption1-medium transition-colors sm:h-6 sm:rounded-[7px] sm:px-2 sm:text-label2-bold",
				isBidPrice
					? "border-trade-green/25 bg-trade-green-muted text-trade-green hover:bg-trade-green-muted"
					: "border-trade-red/25 bg-trade-red-muted text-trade-red hover:bg-trade-red-muted",
				className,
			)}
			onClick={() => {
				if (!price) return;
				onApplyPrice(price);
			}}
		>
			<span className="sm:hidden">{mobileText}</span>
			<span className="hidden sm:inline">{desktopText}</span>
		</Button>
	);
}
